module.exports = __webpack_public_path__ + "static/media/tickethoss-logo.a6a4765b.png";